<script>
import { getInboxClassByType } from 'dashboard/helper/inbox';

export default {
  props: {
    inbox: {
      type: Object,
      default: () => {},
    },
    conversationId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    inboxIcon() {
      const { phone_number: phoneNumber, channel_type: type } = this.inbox;
      const classByType = getInboxClassByType(type, phoneNumber);
      return classByType;
    },
  },
};
</script>
<template>
  <div
    class="inline-flex items-center rounded border brd-highlight divide-x divide-gray-100 dark:divide-gray-700/50 bg-none"
  >
    <div v-if="inbox" class="flex items-center gap-0.5 py-0.5 px-1.5">
      <fluent-icon
        class="txt-muted mr-1"
        :icon="inboxIcon"
        size="14"
      />
      <span class="font-medium txt-muted text-xs">
        {{ inbox.name }}
      </span>
    </div>
    <div class="flex items-center py-0.5 px-1.5">
      <span class="font-medium txt-muted text-xs">
        #{{ conversationId }}
      </span>
    </div>
  </div>
</template>
